import { render, staticRenderFns } from "./c_home_article.vue?vue&type=template&id=693fdea8&scoped=true"
import script from "./c_home_article.vue?vue&type=script&lang=js"
export * from "./c_home_article.vue?vue&type=script&lang=js"
import style0 from "./c_home_article.vue?vue&type=style&index=0&id=693fdea8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693fdea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('693fdea8')) {
      api.createRecord('693fdea8', component.options)
    } else {
      api.reload('693fdea8', component.options)
    }
    module.hot.accept("./c_home_article.vue?vue&type=template&id=693fdea8&scoped=true", function () {
      api.rerender('693fdea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_home_article.vue"
export default component.exports